<template>
  <div class="tile is-child box">
    <p class="title">{{title}}</p>
    <p class="subtitle">{{subtitle}}</p>
    <hr />
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
};
</script>

<style>
</style>
